import { render, staticRenderFns } from "./MenuItemEditor.vue?vue&type=template&id=71c4fda6&"
import script from "./MenuItemEditor.vue?vue&type=script&lang=ts&"
export * from "./MenuItemEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MenuItemEditor.vue?vue&type=style&index=0&id=71c4fda6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports